import { render } from "./Cherished_desire_list.vue?vue&type=template&id=33ea054c&scoped=true"
import script from "./Cherished_desire_list.vue?vue&type=script&lang=js"
export * from "./Cherished_desire_list.vue?vue&type=script&lang=js"

import "./Cherished_desire_list.vue?vue&type=style&index=0&id=33ea054c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ea054c"]])

export default __exports__